// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__228yD","productName":"Table_productName__30JwX"};